<ng-container *ngIf="data && data.length; else noDataTemplate">
    <ng-container *ngFor="let item of data">
        <mat-card class="example-card" (click)="onCardClick(item)" fxLayout="row"
            [ngClass]="{'active-card': wfRunService.activeCard === item || item === activeCard}" fxLayoutGap="4" [id]="tourId.workflows.wfrun.wfRunCard.id">
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="space-around">
                <!-- Add seperate mat-card-header using ngIf and page as the input -->
                <mat-card-header *ngIf="page === 'wfRun'">
                    <hr *ngIf="page === 'wfRun'" class="vertical-line">
                    <div>
                        <mat-icon class="status" [matTooltip]="item?.status"
                            [ngStyle]="{'color': perfDtl[item?.status]?.color}">{{perfDtl[item?.status]?.icon}}</mat-icon>
                    </div>
                </mat-card-header>
                <!-- End of workflow run card header -->
            </div>

            <div fxFlex="90">
                <mat-card-title class="title width-17 ellipses"
                    [matTooltip]="item.workTicketId || wktkt">{{item.workTicketId ||
                    'NA'}}</mat-card-title>
                <!-- button with dropdown -->
                <button mat-icon-button [matMenuTriggerFor]="dropdownMenu" class="dropdownIcon"
                    [id]="tourId.workflows.wfrun.wfRunCardMenu.id">
                    <span class="material-icons-outlined primary large cursor">pending</span>
                </button>
                <mat-menu #dropdownMenu="matMenu" class="matMenu">
                    <div [id]="tourId.workflows.wfrun.wfCardMenu.id">
                        <button mat-menu-item (click)="cf.openInNewTab(item)" [matTooltip]="gitAction">
                            <mat-icon>open_in_new</mat-icon>Github action
                        </button>
                        <button mat-menu-item (click)="wfRunRerun(item)"
                            [disabled]="!authService.permissions['rerun-workflow'] || cf.statusArr.includes(item?.status.toLowerCase())"
                            matTooltip="{{!authService.permissions['rerun-workflow'] ? cf.messages.permissionMsg: rerun}}">
                            <mat-icon>play_circle_outline</mat-icon>Rerun
                        </button>
                        <button mat-menu-item (click)="moreDetails(item)" [matTooltip]="moreDet">
                            <mat-icon>info_outline</mat-icon>More details
                        </button>
                    </div>
                </mat-menu>
                <!--END button with dropdown -->

                <!-- Add seperate mat-card-content using ngIf and page as the input -->
                <mat-card-content *ngIf="page === 'wfRun'">
                    <div class="gray font-smaller">
                        <span [matTooltip]="item.triggeredOn">
                            {{item.triggeredOn | date}}, {{(item.duration | durationFormatter) || 'NA'}}
                        </span>
                    </div>
                    <div class="gray font-smaller" fxLayout="column" fxLayoutGap="2">
                        <div *ngIf="item?.repoName" class="width-17 ellipses">
                            <span [matTooltip]="item.repoName">{{item.repoName}}</span>
                        </div>
                        <div class="width-17 ellipses">
                            <span [matTooltip]="item.author">Author: {{item.author || 'NA'}}</span>
                        </div>
                    </div>
                </mat-card-content>
                <!-- End of workflow run card content -->
            </div>
        </mat-card>
    </ng-container>
</ng-container>

<ng-template #noDataTemplate>
    <app-no-data-available [newData]="getNoData"></app-no-data-available>
</ng-template>